import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    approveToAddNewMember: string;
    upgradeToAddMoreMembers: string;
    noStorageIncrement: ({ memberSeatRate, isOnTrial }: {
        memberSeatRate: string;
        isOnTrial?: boolean;
    }) => string | React.ReactNode;
    hasStorageIncrement: ({ memberSeatRate, storageIncrement, isOnTrial }: {
        memberSeatRate: string;
        storageIncrement?: string;
        isOnTrial?: boolean;
    }) => string | React.ReactNode;
    renewalInfo: ({ renewalPeriod }: {
        renewalPeriod?: string;
    }) => string | React.ReactNode;
    renewalPeriod: {
        /** Monthly billing period */
        MONTHLY: string;
        /** Annual billing period */
        YEARLY: string;
        /** Semi-annual billing period */
        SEMIANNUALLY: string;
    };
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** When approval will add a new member to the account */
            approveToAddNewMember: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccessRequestBody.approveToAddNewMember?c=39mjeztvgk4jo", defaultMessage: "Adds one new member to your account." }));
                },
                enumerable: true,
                configurable: true
            },
            /** When plan has no more seats and needs to be upgraded before new members can be added */
            upgradeToAddMoreMembers: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccessRequestBody.upgradeToAddMoreMembers?c=zs0c0qgj7juy", defaultMessage: "To add more members, upgrade your plan." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Tooltip text displaying new member seat rate and trial info if applicable */
            noStorageIncrement: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ memberSeatRate, isOnTrial }: {
                        memberSeatRate: string;
                        isOnTrial?: boolean;
                    }) => __intl__.intl().formatMessage({ id: "AccessRequestBody.noStorageIncrement?c=o6quewwe4foy", defaultMessage: "Adds one new member to your account for {memberSeatRate} (plus tax){isOnTrial, select, true { after free trial period} other {}}." }, { memberSeatRate: memberSeatRate, isOnTrial: isOnTrial }));
                },
                enumerable: true,
                configurable: true
            },
            /** Tooltip text displaying new member seat rate, storage increment amount andtrial info if applicable */
            hasStorageIncrement: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ memberSeatRate, storageIncrement, isOnTrial }: {
                        memberSeatRate: string;
                        storageIncrement?: string;
                        isOnTrial?: boolean;
                    }) => __intl__.intl().formatMessage({ id: "AccessRequestBody.hasStorageIncrement?c=1c18zo0hisw9i", defaultMessage: "Adds one new member and {storageIncrement} storage to your account for {memberSeatRate} (plus tax){isOnTrial, select, true { after free trial period} other {}}." }, { storageIncrement: storageIncrement, memberSeatRate: memberSeatRate, isOnTrial: isOnTrial }));
                },
                enumerable: true,
                configurable: true
            },
            /** Renewal and cancellation info */
            renewalInfo: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => ({ renewalPeriod }: {
                        renewalPeriod?: string;
                    }) => __intl__.intl().formatMessage({ id: "AccessRequestBody.renewalInfo?c=2oau6xsg79nw9", defaultMessage: "Renews {renewalPeriod}. Cancel anytime." }, { renewalPeriod: renewalPeriod }));
                },
                enumerable: true,
                configurable: true
            },
            /** Renewal period for the plan */
            renewalPeriod: {
                get() {
                    return Object.defineProperties({
                        [__intl__.BOUND_INTL]: this[__intl__.BOUND_INTL] ?? __intl__.getIntl()
                    }, {
                        /** Monthly billing period */
                        MONTHLY: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccessRequestBody.renewalPeriod.MONTHLY?c=3agiyj73w3njq", defaultMessage: "monthly" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Annual billing period */
                        YEARLY: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccessRequestBody.renewalPeriod.YEARLY?c=370itv7rdakl5", defaultMessage: "annually" }));
                            },
                            enumerable: true,
                            configurable: true
                        },
                        /** Semi-annual billing period */
                        SEMIANNUALLY: {
                            get() {
                                return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "AccessRequestBody.renewalPeriod.SEMIANNUALLY?c=173md6fmnsbda", defaultMessage: "semi-annually" }));
                            },
                            enumerable: true,
                            configurable: true
                        }
                    });
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
